import { FormTextInput } from 'components/form-fields';
import { useValidation } from 'hooks/useValidation';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { Fragment, useEffect } from 'react';

export function OcrStringLayout(
    {
        loading = false,
        disabled = false,
        readonly = false,
        layout,
        onChange
    }
) {
    const [_, errors, validate] = useValidation();

    useEffect(() => {
        validateLayout();
    }, [layout.answer]);

    function validateLayout() {
        const required = layout.requiredAnswerCount > 0;
        const rules = [{ fieldName: 'answer', required: required }];
        validate(rules, layout);
    }

    function onValueChange(event) {
        const clonedLayout = { ...layout };

        clonedLayout.answer = event.target.value;

        onChange(clonedLayout);
    }

    return (
        <Fragment>
            <div className={classNames({ "hide-in-print": !readonly, "hidden": readonly })}>
                <FormTextInput
                    loading={loading}
                    disabled={disabled}
                    onChange={onValueChange}
                    value={layout.answer ? layout.answer : ''}
                    headingText={layout.secondaryLayoutTitle}
                    dangerHelperText={errors.answer}
                    maxlength={2000}
                />
            </div>
            <div className={classNames({ "show-in-print": !readonly, "visible": readonly })}>
                <h4 className={classNames({ "bp6-skeleton": loading })}>{layout.secondaryLayoutTitle ? layout.secondaryLayoutTitle : ''}</h4>
                <p className={classNames({ "show-in-print": !readonly, "visible": readonly, "bp6-skeleton": loading })}>{layout.answer ? layout.answer : ''}</p>
            </div>
        </Fragment>
    );
}

OcrStringLayout.propTypes = {
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool
};
